module.exports = __webpack_public_path__ + "static/media/progressBarPlatinum.df5dcd95.svg";